import React from "react";

const StarRating = ({ rating, outOf = 5 }) => {
  return (
    <div className="flex space-x-1">
      {[...Array(outOf)].map((_, index) => (
        <svg
          key={index}
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill={index < rating ? "#FEAD00" : "none"}
          stroke="#FEAD00"
          strokeWidth="1"
          className="w-[23.96px] h-[22.8px]"
        >
          <path d="M12 .587l3.668 7.568L24 9.423l-6 5.848L19.335 24 12 20.201 4.665 24 6 15.271 0 9.423l8.332-1.268z" />
        </svg>
      ))}
    </div>
  );
};

export default StarRating;